import React from "react";
import Logo from "components/Logo";

import { Navigate } from "react-router-dom";

const Login = (props) => {
  const pharmaforce = localStorage.getItem("pharmaforce");
  if (pharmaforce) {
    const { profile } = JSON.parse(pharmaforce);
     return <Navigate to="/clinetdashboard" />
    // if (profile != undefined && profile.roles != undefined && (profile.roles === "PHU" || profile.roles === "PHADM"))
    //   return <Navigate to="/clinetdashboard" />;
    // else
    //   return <Navigate to="/dashboard" />;
   }

  return (
    <div className="h-90vh d-flex align-items-center justify-content-center">
      <div className="text-center">
        <Logo height={50} />
      </div>
    </div>
  );
};

export default Login;
